import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DouyinPremiumFeed from './components/DouyinPremiumFeed';
import AdminPanel from './components/AdminPanel';
import VideoCollection from './components/VideoCollection';
import ApiSettings from './components/ApiSettings';
import SearchPage from './components/SearchPage';
import GroupPage from './components/GroupPage';
import ChatInterface from './components/ChatInterface';
import AnalyticsPage from './components/AnalyticsPage';
import HlsManager from './components/HlsManager';
import AdminTools from './components/AdminTools';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DouyinPremiumFeed />} />
        <Route path="/chat" element={<ChatInterface />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/analytics" element={<AnalyticsPage />} />
        <Route path="/admin/collection" element={<VideoCollection />} />
        <Route path="/admin/api-settings" element={<ApiSettings />} />
        <Route path="/admin/hls" element={<HlsManager />} />
        <Route path="/admin/tools" element={<AdminTools />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/groups" element={<GroupPage />} />
      </Routes>
    </Router>
  );
}

export default App;
